module.exports = __webpack_public_path__ + "static/media/experiencePlaceholder.c2fd6b6b.svg";